<div class="bloco-card">
  <div class="bloco-topo">
    <div class="bloco-topo-info">
      <div class="titulo-wrap">
        <h3 class="bloco-title">Buscas salvas</h3>
      </div>
    </div>
    <div class="bloco-acoes">
      <a routerLink="/busca/salvas" class="btn-outline">Ver todas</a>
    </div>
  </div>

  <div class="bloco-content">
    <ng-container *ngIf="!loading; else skeleton">
      <div
        class="search-item"
        *ngFor="let search of searches"
        (click)="abrirBusca(search)"
      >
        <div class="search-icone">
          <mat-icon aria-hidden="true">search</mat-icon>
        </div>
        <div class="search-mid">
          <span class="search-name">{{ search.searchName || '(sem nome)' }}</span>
          <span class="search-date">
            Atualizada em {{ search.updatedAt || '-' }}
          </span>
        </div>
        <!-- <span class="badge-novas" *ngIf="search.newWorks > 0">NOVAS</span> -->
      </div>

      <div class="empty-state" *ngIf="searches.length === 0">
        <span>Nenhuma busca salva encontrada.</span>
      </div>
    </ng-container>

    <ng-template #skeleton>
      <div class="skeleton">
        <div class="skeleton-item" *ngFor="let i of [1,2,3,4,5,6]">
          <div class="skeleton-icon"></div>
          <div class="skeleton-line"></div>
        </div>
      </div>
    </ng-template>
  </div>
</div>